import { AlertTriangle, CheckCircle2, CircleDashed, Pause } from 'lucide-react';
import type { SectionLayoutState } from './formSchemaTypes';

export function SectionLayoutStatusBadge({
  state,
}: {
  state: SectionLayoutState;
}) {
  if (state.kind === 'valid') {
    if (state.template.status === 'paused') {
      return (
        <span
          className='inline-flex items-center text-amber-600'
          title='Paused custom layout'
        >
          <Pause className='h-3.5 w-3.5' aria-hidden />
        </span>
      );
    }
    return (
      <span
        className='inline-flex items-center text-green-700'
        title='Live custom layout'
      >
        <CheckCircle2 className='h-3.5 w-3.5' aria-hidden />
      </span>
    );
  }
  if (state.kind === 'invalid') {
    return (
      <span
        className='inline-flex items-center text-destructive'
        title={state.reason}
      >
        <AlertTriangle className='h-3.5 w-3.5' aria-hidden />
      </span>
    );
  }
  return (
    <span
      className='inline-flex items-center text-muted-foreground'
      title='No custom layout'
    >
      <CircleDashed className='h-3.5 w-3.5' aria-hidden />
    </span>
  );
}
